<template>
  <router-view></router-view>
</template>

<script>

export default {
  name: 'App',
  watch: {
    '$route'() {
      this.setFullHeight();
      // this.reFresh();
    },
  },
  mounted() {
    this.setFullHeight();
    // this.reFresh();
  },
  methods: {
    setFullHeight(){
      // First we get the viewport height and we multiple it by 1% to get a value for a vh unit
      let vh = window.innerHeight * 0.01;
      // Then we set the value in the --vh custom property to the root of the document
      document.documentElement.style.setProperty('--vh', `${vh}px`);
    },
    // reFresh (){
      // window.onresize = function(){
      //   document.location.reload();
      // };
      // window.orientationchange = orientationEventHandler;
      // window.addEventListener('orientationchange', orientationEventHandler, false);
      // function orientationEventHandler(){
      //   var orientation = window.orientation;
      //   // 회전했을 경우 처리
      //   if(orientation == 90 || orientation == -90){
      //     location.reload();
      //   } else {
      //     // 회전하지 않았을 경우 처리
      //     location.reload();
      //   }
      // }
    // }
  }
}
</script>

<style>
#app {
  font-family: Avenir, Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  height: 100%;
  text-align: center;
  color: #232A38;
  margin: 0;
  padding: 0;
}

@import url('@/assets/css/reset.css');
@import url('@/assets/css/vue-select.css');
</style>
